






















































import { NullableString } from "@/code/Types";
import { Component } from "vue-property-decorator";
import BasePage from "@/views/base/BasePage";
import { opportunityStore } from "@/store/modules/OpportunityStore";
import { OpportunityData } from "@/models/OpportunityData";
import { clientsStore } from "@/store/modules/ClientStore";
import { Routes } from "@/router/Routes";
import { ClientData } from "@/models/ClientData";
import { accountStore } from "@/store/modules/AccountStore";

@Component
export default class extends BasePage {
  search: NullableString = null;
  client!: ClientData;

  headers = [
    { text: "Client Name", value: "clientFullName" },
    { text: "Line Of Business", value: "opportunityProductLine" },
    { text: "Status", value: "status" },
    { text: "Carrier", value: "insurance" },
    { text: "Policy Number", value: "policyNumber" },
    { text: "Last Updated", value: "modifiedOn" },
    { text: "Financial Advisor", value: "agentFullName" },
  ];

  created(): void {
    this.client = clientsStore.current;
  }

  get allOpportunity(): OpportunityData[] {
    return opportunityStore.entities;
  }

  async showCaseDetail(id: string): Promise<void> {
    await this.$router.push({
      name: Routes.NEW_BUSINESS_CASE_DETAIL,
      params: { id },
    });
  }
  get agentFullName(): NullableString | undefined {
    return accountStore.user?.agentFullName;
  }
}
